import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_FONTS } from '../pdfTypography';

const styles = StyleSheet.create({
  container: {
    marginBottom: 10,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 1,
  },
  bullet: {
    fontSize: PDF_FONTS.body,
    color: '#000000',
    width: 12,
    lineHeight: 2,
  },
  text: {
    fontSize: PDF_FONTS.body,
    color: '#000000',
    flex: 1,
    lineHeight: 2,
  },
});

interface BulletListProps {
  items: string[];
}

const BulletList: React.FC<BulletListProps> = ({ items }) => (
  <View style={styles.container}>
    {items.map((item, i) => (
      <View key={i} style={styles.row}>
        <Text style={styles.bullet}>{'•'}</Text>
        <Text style={styles.text}>{item}</Text>
      </View>
    ))}
  </View>
);

export default BulletList;
